import { render, staticRenderFns } from "./HeadingElement.vue?vue&type=template&id=5d77c9b4&scoped=true&"
import script from "./HeadingElement.vue?vue&type=script&lang=js&"
export * from "./HeadingElement.vue?vue&type=script&lang=js&"
import style0 from "./HeadingElement.vue?vue&type=style&index=0&id=5d77c9b4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d77c9b4",
  null
  
)

export default component.exports